import * as yup from "yup";

export default function createChecklistSchema() {
  return yup.object().shape({
    name: yup.string().required(),
  });
}
